var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSound = function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    clipPath: "url(#sound_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5h1.19a5.5 5.5 0 0 0 3.52-1.275l2.97-2.474a.5.5 0 0 1 .82.384v13.73a.5.5 0 0 1-.82.384l-2.97-2.474A5.5 5.5 0 0 0 5.19 15.5H4A1.5 1.5 0 0 1 2.5 14v-4A1.5 1.5 0 0 1 4 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M15.535 15.536a5 5 0 0 0 0-7.071M18.535 17.464a7.73 7.73 0 0 0 0-10.929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sound_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSound;